<template lang="pug">
.header-void
  .header
    .header__container(:class="headerClasses")
      .header__side
        transition(
          name="fade"
          mode="out-in"
        )
          RouterLink.logotype(
            v-if="!$route.meta.sidebar"
            :to="{ name: 'Root' }"
          )
        //- transition(
        //-   name="fade"
        //-   mode="out-in"
        //- )
        //-   template(v-if="isAuthenticated && !$route.meta.sidebar")
        //-     .ml-3.d-flex.h-100
        //-       RouterLink.header-button.header-nav-item(
        //-         v-for="link in navItems"
        //-         :key="`${link.id}`"
        //-         :label="link.label"
        //-         :to="link.url"
        //-       ) 
        //-         .header-button__prepend(v-if="link.icon")
        //-           .mdi.header-button__icon(:class="`mdi-${link.icon}`")
        //-         .header-button__content
        //-           .header-button__label {{ link.label }}

      .header__side
        template(v-if="isAuthenticated")
          HeaderDropdown(
            :label="user.name || `User #${user.id}`"
            :subtitle="user.email"
            alignment="right"
          )
            template(#prepend)
              UiAvatar(
                :src="user.avatar"
                :label="user.name || user.email"
                size="sm"
              )
            template(#dropdown)
              MiniProfile
        template(v-else)
          form.auth-button-form(
            v-for="link in oauth2Providers"
            :key="`login-link-${link.slug}`"
            :action="link.url"
            method="post"
          )
            input(
              type="hidden"
              :value="csrfToken"
              name="authenticity_token"
            )
            HeaderButton(
              :label="link.label"
              :subtitle="$t('user.login_with')"
              subtitle-top
              type="submit"
            )
              template(#prepend)
                img.header-button__icon(:src="link.icon")
</template>

<script>
import { mapGetters } from "vuex";
import oauth2Providers from "@/common/login_providers";
import CompanySwitcher from "@/components/CompanySwitcher.vue";
import MiniProfile from "@/components/MiniProfile.vue";
import Company from "@/models/Company.js";
import HeaderButton from "./Header/HeaderButton.vue";
import HeaderDropdown from "./Header/HeaderDropdown.vue";

export default {
  components: {
    MiniProfile,
    HeaderButton,
    HeaderDropdown,
    CompanySwitcher,
  },

  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    ...mapGetters("company", ["currentCompany", "hasCompanies"]),

    navItems() {
      return [
        {
          id: "companies",
          url: "/companies",
          label: this.$t("menu.companies"),
          icon: "domain",
          allowedRoles: Company.role.ADMIN,
        },
        {
          id: "resellers",
          url: "/resellers",
          label: this.$t("menu.resellers"),
          icon: "storefront",
        },
        {
          id: "super_admins",
          url: "/super_admins",
          label: this.$t("menu.super_admins"),
          icon: "account-cog",
        },
        {
          id: "automation",
          url: "/automation",
          label: this.$t("menu.automation"),
          icon: "auto-fix",
        },
        {
          id: "admin_tools",
          url: "/admin_tools",
          label: "menu.admin_tools",
          icon: "wrench-outline",
          allowedRoles: ["super_admin"],
        },
      ];
    },

    headerClasses() {
      return {
        container: !this.isAuthenticated,
        "container-fluid": this.isAuthenticated,
      };
    },

    oauth2Providers() {
      return oauth2Providers;
    },

    csrfToken() {
      return document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    },
  },

  methods: {
    login(link) {
      this.$store.dispatch("login", {
        oauth2: link.slug,
      });
    },

    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/stylesheet/_variables.scss";

:root {
  --header-height: 70px;
}

.header {
  &-void {
    height: var(--header-height);
  }

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--header-height);
  background: $white;
  box-shadow:
    0 1px 3px rgba($bb-dark, 0.08),
    0 5px 10px rgba($bb-dark, 0.04);
  z-index: 1000;
  transition: all ease-out 230ms;

  .application-layout.sidebar & {
    left: var(--ui-sidebar--width);
  }

  &__container {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    height: 100%;
    padding: 0 2rem;
  }

  &__side {
    display: flex;
    align-items: center;
  }
}

.auth-button-form {
  align-self: stretch;

  & + & {
    margin-left: -1px;
  }
}
</style>
